import { memo, useContext, useEffect, useState } from 'react';
import { MovableTypePrintingContext } from './MovableTypePrintingProvider';
import GamePrintingMovableType from './GamePrintingMovableType';

interface GamePrintingMovableTypesProps {
}

export default memo(function GamePrintingMovableTypes(props: GamePrintingMovableTypesProps) {
  const { theText } = useContext(MovableTypePrintingContext);
  const [movableTypePos, setMovableTypePos] = useState<Array<string>>([]);

  useEffect(() => {
    // setTheText(PRGRESS_TYPE[props.progressIndex].text);
    setMovableTypePos(
      ['left', 'right']
        .map((dir) => Array(theText.length / 2).fill(0).sort(() => .5 - Math.random()).slice(0, Math.ceil(theText.length / 2)).map((_, i) => `${dir}-${i}`))
        .flat()
        .sort(() => .5 - Math.random())
    );
  }, [theText]);

  return (
    <div className="game-printing-movable-types" data-index={theText}>
      {theText.split('').map((t, i) => <GamePrintingMovableType key={`${t}_${i}`} imgIndex={i} text={t} posAlias={movableTypePos[i]}></GamePrintingMovableType>)}
    </div>
  )
})
